import _ from "lodash";
import { usePageContext } from "@providers/PageProvider";
import { useStrapiContext } from "@providers/StrapiProvider";
import getter from "@services/OfferService/getter";
const View = () => {
  const { offer } = usePageContext();
  const { str } = useStrapiContext();
  return (
    <section data-scroll-section>
      {str.renderComp(getter.details(offer))}
    </section>
  );
};
export default View;
